import { render } from "./MyStudentsRecord.vue?vue&type=template&id=08112370"
import script from "./MyStudentsRecord.vue?vue&type=script&lang=js"
export * from "./MyStudentsRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__